<template lang="pug">
v-modal(:visible="tipWarning",
  title='提示',
  @closemodal="closemodal()"
  )
  div.message
    p(v-html="message")
    .btn-container
      label(
          v-if="hasRemember"
        )
        v-checkbox(
          v-model="remember"
        )
        span.remember 知道了，不再提醒
      button.btn.btn-primary.btn-small.btn-mgr(
        v-else-if="!isOutTime"
        @click="toWebsite()"
        type="button"
        ) 去设置

      button.btn.btn-primary.btn-small.btn-mgr(
        @click="closemodal()",
        type="button"
        ) 确认

</template>
<script>
  /* global _ */
  export default {
    props: {
      type: Number,
      time: String,
      defaulttime: String
    },
    data () {
      return {
        tipWarning: false,
        remember: false
      }
    },
    computed: {
      isOutTime () {
        return new Date(this.time).getTime() >= new Date(this.defaulttime).getTime()
      },
      message () {
        const Messages = [
          '',
          '',
          '检测到您帐号内有添加原MV代码建立的站点，由于360分析代码已覆盖全部功能，我们计划在<em class="warning">2018年7月10日</em>作如下改变：360分析将不会更新原MV代码监测数据，MV代码监测的数据只用于广告定向投放，添加360分析代码站点报告查看功能正常使用。',
          '您帐号内的站点添加的为原MV监测代码，由于360分析代码已覆盖全部功能，我们计划在<em class="warning">2018年7月10日</em>作如下改变：360分析将不会更新原MV代码监测数据，MV代码监测的数据只用于广告定向投放，请重新设置站点并添加360分析代码以免影响您的正常使用。'
        ]
        const mvTip = '360分析于2018年7月10日已停止更新原MV代码监测数据，MV代码监测的数据只用于广告定向投放，请重新设置站点并添加360分析代码。'
        return this.isOutTime ? mvTip : Messages[this.type]
      },
      hasRemember () {
        return +this.type === 2
      }
    },
    mounted () {
      this.tipWarning = true
    },
    methods: {
      closemodal () {
        this.tipWarning = false
        this.remember && this.setRemember()
      },
      setRemember () {
        if (!_.has(localStorage, '__fx_notypetip_usrs')) {
          localStorage.__fx_notypetip_usrs = '[]'
        }
        const users = JSON.parse(localStorage.__fx_notypetip_usrs)
        users.push(window.$userName)
        localStorage.__fx_notypetip_usrs = JSON.stringify(users)
      },
      toWebsite () {
        this.closemodal()
        this.$router.push('/setting/sites')
      } 
    }
  }
</script>
<style scoped>
@import '../css/base/variables.css';

.message {
  width: 500px;
  padding: 25px 35px;
  font-size: 14px;
}
.remember {
  margin-left: 5px;
  margin-right: 20px;
  font-size: 12px;
}
.btn-container {
  text-align: center;
  margin-top: 35px;
}
</style>



// WEBPACK FOOTER //
// codetipModal.vue?3e6cffbe